import { Box, Button, useTheme } from "@mui/material";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import PersonFormIcon from "../../Icon/PersonFormIcon";
import MenuIcon from "@mui/icons-material/Menu";
import MaterialIcon from "../../Icon/MaterialIcon";
import NewSideBar from "../../NewSideBar";
export default function MobileNavgation() {
  const theme = useTheme();
  const [menu, setMenu] = useState(false);
  const handleClick = () => {
    setMenu(!menu);
  };
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: " 12px",
        position: "fixed",
        bottom: "0.8rem",
        borderRadius: "32px",
        left: 0,
        right: 0,
        boxShadow: "0px 2px 6px 0px rgba(118, 131, 145, 0.10)",
        zIndex: 1000,
        width: "100%",
        background: theme.palette.mode === "dark" ? "#1E232D" : "#FFF",
        height: "50px",
      }}
    >
      <Button onClick={handleClick}>
        <MenuIcon sx={{ color: "#1e6afd" }} />
      </Button>
      {menu && <NewSideBar mobileOpen={menu} onClose={() => setMenu(false)} />}
      <Link
        to={"/dashboard/mobileNotifcation"}
        style={{ textDecoration: "none" }}
      >
        <i className="icon-Bell"> </i>{" "}
      </Link>
      <Link style={{ textDecoration: "none" }}>
        <MaterialIcon />
      </Link>
    </Box>
  );
}
